import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function noCountyEmailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const countyEmailPattern = /lacounty\.gov/i;
    return countyEmailPattern.test(control.value) ? { noCountyEmail: 'LA County emails are forbidden'} : null;
  };
}
